var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnLeftDecor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 32,
    viewBox: "0 0 15 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000121548 31.6667L-0.00012207 23.2815L-0.00012207 8.38532L-0.00012207 8.2016e-05L11.2414 11.176L10.2991 13.3113L7.45883 15.8334L10.2991 18.3555L11.2414 20.4908L-0.000121548 31.6667Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0929 15.8333L12.0465 13.1923L15.0001 15.8333L12.0465 18.4744L9.0929 15.8333Z",
    fill: "white",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnLeftDecor);
export default __webpack_public_path__ + "static/media/btn-left-decor.1387783d36c0d122b2ffd5081b12d9a2.svg";
export { ForwardRef as ReactComponent };